"use client"

import { BedSingle } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BedSingleIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BedSingleIcon = component(Icon)({ as: BedSingle })
